<script setup lang="ts">
import { DonutChart } from "@/components/ui/chart-donut";
import { PastReservation } from "../types";

const props = defineProps<{
    data: PastReservation[];
}>();

const colors = [
    "hsla(260, 77%, 70%, 1)",
    "hsla(260, 77%, 70%, 0.75)",
    "hsla(260, 77%, 70%, 0.5)",
    "hsla(260, 77%, 70%, 0.25)",
];
</script>

<template>
    <DonutChart
        :index="'name'"
        :category="'total'"
        :data="data"
        :colors="colors"
    />
</template>
